import { jsx } from '@emotion/react/jsx-runtime';
import { DismissButton } from '@nettbureau/button';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { useCss, parseSpacing } from '@nettbureau/styling';

/**
 * A button used for removing chips.
 */ const ChipRemoveButton = createPolymorphicComponent((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('ChipDismissButton', props, ref);
    const { 'aria-label': ariaLabel = 'Remove', css, ...otherProps } = mergedProps;
    const buttonCss = useCss(({ theme, mixins })=>mixins.spacing({
            margin: {
                x: `-${parseSpacing(theme, '2xs')}`
            }
        }));
    return /*#__PURE__*/ jsx(DismissButton, {
        ...otherProps,
        ref: mergedRef,
        "aria-label": ariaLabel,
        css: [
            buttonCss,
            css
        ]
    });
});

export { ChipRemoveButton };
//# sourceMappingURL=chip-remove-button.js.map
